import React, { useState, useEffect } from 'react';
import { Document, Page, View, Text, PDFViewer, Image, StyleSheet, pdf } from '@react-pdf/renderer';
import ImagenQR from './tools/imagenQR';
import Logo from './imagenes/escudoIseP.png';
import Credencial from './imagenes/credencialProceso.png';
import logoProvincia from './imagenes/logoProvincia2024.jpg';
import textoIsep from './imagenes/textoIsep2024.jpg';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { saveAs } from 'file-saver';

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

function GeneraCredencial() {
  const { width } = useWindowSize();
  const query = new URLSearchParams(useLocation().search);
  const [muestro, setMuestro] = useState(false);
  const [procesando, setProcesando] = useState(false);
  const [postulante, setPostulante] = useState(null);

  const obtieneCertificado = async () => {
    const client = axios.create({
      baseURL: 'https://wwwa.isepsantafe.net.ar/expedientes/procesos/devuelvePostulante/',
    });

    try {
      const dni = query.get('dni');
      const res = await client.post(`/${dni}?idProceso=proceso_2026-2027s`);
      console.log(res)
      if (res.data.length > 0) {
        setPostulante(res.data[0]);
        setMuestro(true);
      } else {
        alert('No hay resultados con ese DNI. Comuníquese con areainscripcionalumnado@isepsantafe.edu.ar');
      }
    } catch (error) {
      console.error('Error al obtener el certificado', error);
    }
  };

  useEffect(() => {
    obtieneCertificado();
  }, []);

  const MyDocument = () => {
    if (!postulante) return null;
    const direccionQR = `${postulante.id}-${postulante.dni}`;

    return (
      <Document title={`Credencial Proceso ${postulante.dni}`} onLoadError={console.error}>
        <Page size="A4">
          <View style={{ width: '100%', marginTop: 20, padding: 1 }}>
            <Image style={{ width: 250 }} src={logoProvincia} />
            <Image style={{ width: 200, position: 'absolute', alignSelf: 'flex-end' }} src={textoIsep} />
          </View>

          <View style={{ textAlign: 'center', margin: 55, paddingTop: 1 }}>
            <Text style={{ fontSize: 25 }}>Credencial de Proceso de Selección</Text>
            <Image style={{ width: 350, marginLeft: 70, marginTop: 120, position: 'absolute' }} src={Credencial} />
            <Text style={{ marginTop: 266, marginLeft: 120, fontSize: 20, position: 'absolute' }}>{postulante.dni}</Text>
            <Text style={{ marginTop: 290, marginLeft: 120, fontSize: 10, position: 'absolute' }}>{`001-${postulante.id}`}</Text>
            <Text style={{ marginTop: 302, marginLeft: 155, fontSize: 10, position: 'absolute' }}>{`${postulante.apellido}, ${postulante.nombres}`}</Text>

            <View style={{ marginTop: 139, marginLeft: 240, position: 'absolute' }}>
              <ImagenQR direccion={direccionQR} tamaño="495" />
            </View>

            <Text style={{ fontSize: 5, transform: 'rotate(270deg)', alignSelf: 'left', marginLeft: 354, marginTop: 210, position: 'absolute' }}>
              La presente no constituye certificación de identidad.
            </Text>

            <Text style={{ fontSize: 15, fontStyle: 'oblique' }}>
              Por favor recorte por la línea indicada y conserve la presente credencial de proceso de selección para su identificación en cada una de las etapas
            </Text>
          </View>
        </Page>
      </Document>
    );
  };

  const generatePdfDocument = async (dni) => {
    try {
      setProcesando(true);
      const nombreArchivo = `Credencial Postulante ${dni}`;
      const blob = await pdf(<MyDocument />).toBlob();
      saveAs(blob, nombreArchivo);
      setProcesando(false);
    } catch (error) {
      console.error('Error generando el PDF', error);
      setProcesando(false);
    }
  };

  if (!muestro || !postulante) return <h1>Cargando...</h1>;

  return (
    <>
      {width < 480 ? (
        <div style={{ textAlign: 'center' }}>
          <img src={Logo} style={{ width: '100px' }} alt="Escudo ISEP" />
          <h1>Descargue su Credencial del proceso 2026-2027</h1>
          <h4>Postulante {postulante.apellido}</h4>
          <button className="btn btn-primary" onClick={() => generatePdfDocument(postulante.dni)} disabled={procesando}>
            {procesando ? 'Procesando...' : 'DESCARGAR'}
          </button>
        </div>
      ) : (
        <PDFViewer showToolbar={false} style={{ width: '100%', height: '100vh' }}>
          <MyDocument />
        </PDFViewer>
      )}
    </>
  );
}

export default GeneraCredencial;

